import React from 'react'
import ChangePassword from '../../components/jsx/profile/ChangePasswordPage.jsx/ChangePassword'

const ChangePasswordPage = () => {
  return (
    <div>
        <ChangePassword />
    </div>
  )
}

export default ChangePasswordPage